export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLight-Cyrillic-00ab96c075ba002b61846a15f8206684.woff2";